import { useTranslation } from "react-i18next";
import { InlineSwitcher } from "../InlineSwitcher";
import { LANGUAGE_OPTIONS } from "./constants";
import type { SupportedLanguage } from "./types";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const activeLanguage: SupportedLanguage =
    i18n.resolvedLanguage === "en" ? "en" : "de";

  return (
    <InlineSwitcher<SupportedLanguage>
      value={activeLanguage}
      options={LANGUAGE_OPTIONS}
      onChange={i18n.changeLanguage}
      listClassName="text-sm"
      separator={<span className="text-gray-300">|</span>}
    />
  );
};
